// 路由变化 → page_view。在 App.js 里对 createBrowserRouter 的 router 调一次 initPageViews(router)。
// 只比较 pathname（查询串里可能有订单号）；首屏那条带 document.referrer（外站来源），站内刷新不带。
import { initAnalytics, track } from './track';

let started = false;
let lastPath = null;

const externalReferrer = () => {
    try {
        const ref = document.referrer;
        if (!ref) return undefined;
        const host = new URL(ref).hostname;
        return host && host !== window.location.hostname ? ref : undefined;
    } catch {
        return undefined;
    }
};

export const recordPageView = (pathname, { initial = false } = {}) => {
    if (!pathname || pathname === lastPath) return;
    lastPath = pathname;
    track('page_view', undefined, { page: pathname, ref: initial ? externalReferrer() : undefined });
};

export const initPageViews = (router) => {
    if (started) return;
    started = true;
    try {
        initAnalytics();
        recordPageView(router?.state?.location?.pathname || window.location.pathname, { initial: true });
        if (router && typeof router.subscribe === 'function') {
            router.subscribe((state) => {
                try {
                    recordPageView(state?.location?.pathname);
                } catch {
                    // 静默
                }
            });
        }
    } catch {
        // 静默
    }
};

/** 只给单测用 */
export const __resetPageViewsForTests = () => {
    started = false;
    lastPath = null;
};
